import { DATA_STATE_SELECTED } from '../../../../constants';
import { getBorderStyle as getGlobalBorderStyle } from './global';
export function getBorderStyle(transformer) {
    const globalBorderStyle = getGlobalBorderStyle(transformer);
    return Object.freeze({
        button: {
            add: {
                default: { value: globalBorderStyle.dashed },
            },
            secondary: {
                default: { value: globalBorderStyle.solid },
            },
            plain: {
                withBorder: {
                    dataStates: {
                        [DATA_STATE_SELECTED]: { value: globalBorderStyle.solid },
                    },
                },
            },
        },
        form: {
            input: { value: globalBorderStyle.solid },
            select: {
                box: { value: globalBorderStyle.solid },
            },
            datepicker: {
                date: { value: globalBorderStyle.solid },
            },
            checkbox: { value: globalBorderStyle.solid },
            radioButton: { value: globalBorderStyle.solid },
        },
        modal: { value: globalBorderStyle.solid },
        menuItem: {
            dataStates: {
                [DATA_STATE_SELECTED]: { value: globalBorderStyle.solid },
            },
        },
        containerWithBorder: { value: globalBorderStyle.solid },
        containerDragAndDrop: { value: globalBorderStyle.dashed },
        divider: { value: globalBorderStyle.solid },
        circle: {
            smallAttentional: { value: globalBorderStyle.solid },
        },
    });
}
